export const DEEP_LINK_PREFIX_LOCAL = "lalocal://";

export const TRAY_ID = "-JVbWhw425ocketyrQzko";

export const ToDesktopDownloadLinks = {
    Universal: `https://dl.todesktop.com/${process.env.TODESKTOP_APP_ID}`,
    MacDmg: `https://dl.todesktop.com/${process.env.TODESKTOP_APP_ID}/mac/dmg/x64`,
    MacAppleSilicon: `https://dl.todesktop.com/${process.env.TODESKTOP_APP_ID}/mac/dmg/arm64`,
    Windows: `https://dl.todesktop.com/${process.env.TODESKTOP_APP_ID}/windows/nsis/x64`,
    Linux: `https://dl.todesktop.com/${process.env.TODESKTOP_APP_ID}/linux/appImage/x64`,
};
